export enum ProfileFilterEnum {
  USER = "Usuário",
  MANAGER = "Ponto Focal",
  ADMIN = "Administrador",
  RESET = "Todos",
  VC = "Gestor do contrato",
  ACCESS_ADMIN = "Administrador de acesso",
}
